export enum AdditionForLaundryType {
  Day = 0,
  Month = 1,
}
